import axios from 'axios'

const ARTISTS_REST_API_URL = "https://hackathon-staged.herokuapp.com/artists"

class ArtistService {

    getArtists() {
        return axios.get(ARTISTS_REST_API_URL);
    }

    getArtist(artistId) {
        return axios.get(`${ARTISTS_REST_API_URL}/${artistId}`);
    }
}

export default new ArtistService;